import React from 'react';
import PropTypes from 'prop-types';
import IconLabel from '../util/IconLabel';
import styles from './CollectionButton.css';
import CapacitorRipple from './Ripple';
import { commonMessages } from '../messages/Common';
import { injectIntl, intlShape } from 'react-intl';

const CollectionButton = props => {
  return (
    <button
      className={styles.button}
      onClick={props.onClick}
      aria-label={
        props.active
          ? props.intl.formatMessage(commonMessages.removeFromCollection)
          : props.intl.formatMessage(commonMessages.saveToCollection)
      }
    >
      <CapacitorRipple version="center" />
      <div>
        {props.active ? (
          <IconLabel name="heart-block" size="default" />
        ) : (
          <IconLabel name="heart" size="default" />
        )}
      </div>
    </button>
  );
};

CollectionButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  active: PropTypes.bool.isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(CollectionButton);
